export default __webpack_public_path__ + "static/media/customer_not-selected_skyblue.536154e4.svg";